<style lang="sass">
.reservations .navbar {
  margin-bottom: 0;
}

.plus {
  color: red;
}

.minus {
  color: blue;
}
</style>

<template>
  <div class="reservations" v-if="isReady">
    <goal-modal
      :api-result="goalApiResult"
      v-ref:goal-modal></goal-modal>
    <layout :shop="shop" :date.sync="date" :info-count="infoCount">
      <template slot="header">
        <form v-if="date" class="navbar-form navbar-left" role="search">
          <reservation-filter
            :display-statuses.sync="displayStatuses"></reservation-filter>
        </form>
        <form v-if="date" class="navbar-form navbar-left" role="search">
          <div class="form-group">
            <span>お断り数</span>
          </div>
          <div class="form-group ds-input-group">
            <button type="button" class="btn btn-default" @click="decrementRejectCount">
              <span class="glyphicon glyphicon-minus" aria-hidden="true"></span>
            </button>
            <input type="text" placeholder="0" disabled style="width: 45px; text-align: right;" v-model="rejectCount" class="form-control"></input>
            <button type="button" class="btn btn-default" @click="incrementRejectCount">
              <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
            </button>
          </div>
        </form>
        <form v-if="date" class="navbar-form navbar-left" role="search" onsubmit="return false;">
          <div class="form-group">
            <div class="input-group">
              <input type="text" placeholder="ナマエ/お客様番号" v-model="searchStr" class="form-control" v-on:keypress.enter="search"></input>
              <span class="input-group-addon glyphicon glyphicon-search" aria-hidden="true" @click.prevent="search"></span>
            </div>
          </div>
        </form>
        <div class="navbar-text">
          <span class="today-goal">目標: {{ todayGoalStr }}</span>
          <span class="today-reservation-count">現状: {{ reservationCountStr }}</span>
          <span class="result">差分: <span v-bind:class="resultNumClass">{{ resultStr }}</span><span>
            <span @click="showGoalModal" class="glyphicon glyphicon-list-alt"></span>
            <span class="dropdown">
              <a href="javascript:void(0)" class="dropdown-toggle"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                ホットペッパー: {{ sumHotpepperPoint | locale }}pt
              </a>
              <ul class="dropdown-menu">
                <li v-for="item in hotpepperPointReservations"
                    :key="item.pk">
                  <a href="javascript:void(0)">
                    {{ item.startAt | time }}
                    {{ item | reservationCustomerName }}

                    {{ item.hotpepperPoint | locale }}pt
                  </a>
                </li>
              </ul>
            </span>
        </div>
        <reservation-search v-ref:search :shop="shop" />
      </template>
      <li slot="alert" v-show="!isWebSocketConnected">
        <a><span class="glyphicon glyphicon-alert" aria-hidden="true"></span></a>
      </li>
      <div class="row">
        <div class="col-md-12">
          <reservations-table
            :shop="shop"
            :date="date"
            :display-statuses="displayStatuses"
            @update-reservations="onUpdateReservations"
          ></reservations-table>
        </div>
      </div>
    </layout>
  </div>
</template>


<script>
import moment from 'moment'
import { cloneDeep } from 'lodash'
import { isWebSocketConnected } from 'getters'

export default {
  name: 'reservations',
  route: {
    data({to: {params: {shopId, year, month, day}}}) {
      var data = {
        date: moment([year, month - 1, day]).format('YYYY-MM-DD'),
      }

      this.shop = null

      let requests = [
        this.apiGet(`/api/1.0/shops/${shopId}`, {page_size: -1}).then(response => {
          return {'shop': response.body.data}
        }),
        this.apiGet(`/api/1.0/informations/`, {page_size: -1}, {shopAs: shopId}).then(response => {
          return {'infoCount': response.body.count}
        }),
      ]
      return Promise.all(requests).then(results => {
        return results.reduce((r1, r2) => Object.assign(r1, r2), data)
      })
    },
  },
  data() {
    return {
      hotpepperPointReservations: [],
      shop: null,
      date: null,
      searchStr: '',
      rejectCount: 0,
      infoCount: 0,
      displayStatuses: [],
      goalApiResult: {},
      todayGoal: null,
      reservationCount: null,
      result: null,
    }
  },
  computed: {
    sumHotpepperPoint() {
      return this.hotpepperPointReservations.map(x => x.hotpepperPoint).reduce((a, b) => a + b, 0)
    },
    isReady() {
      return Boolean(this.shop)
    },
    todayGoalStr () {
      if (this.todayGoal === null) {
        return '--'
      }
      return this.todayGoal + '人'
    },
    reservationCountStr () {
      if (this.reservationCount === null) {
        return '--'
      }
      return this.reservationCount + '人'
    },
    resultStr () {
      if (this.result === null) {
        return '--'
      }
      if (this.result < 0) {
        return 'マイナス' + Math.abs(this.result) + '人'
      }
      return this.result + '人'
    },
    resultNumClass () {
      if (this.result === null) {
        return
      }
      if (this.result > 0) {
        return 'plus'
      } else if (this.result < 0) {
        return 'minus'
      }
    },
  },
  methods: {
    onUpdateReservations(reservations) {
      let hotpeppers = reservations.filter(x => Boolean(x.hotpepperPoint) && !x.isRemoved && x.status !== 5)
      this.hotpepperPointReservations = hotpeppers.map(cloneDeep)
    },
    search () {
      if (this.searchStr) {
        this.$refs.search.search(this.searchStr)
      }
    },
    fetchGoalData () {
      let year = this.$route.params.year
      let month = this.$route.params.month
      let day = this.$route.params.day
      let shopId = this.$route.params.shopId
      this.apiGet(`/api/1.0/reservations/goal/${year}/${month}/${day}/`, null, {shopAs: shopId}).then(response => {
        let today = moment(`${year}-${month}-${day}`)
        let tmp = response.body.rows.find(x => today.isSame(x.date))
        this.todayGoal = tmp.goalNumber
        this.reservationCount = tmp.reservationCount
        this.result = tmp.result
        this.goalApiResult = response.body
      })
    },
    fetchRejectCount () {
      let shopId = this.$route.params.shopId
      let date = moment().format('YYYY-MM-DD')
      let data = {
        date: date,
        shop: shopId,
      }
      this.apiGet(`/api/1.0/shops/reject-counter/`, data, {shopAs: shopId}).then(response => {
        this.rejectCount = response.body.count
      })
    },
    decrementRejectCount () {
      let shopId = this.$route.params.shopId
      let date = moment().format('YYYY-MM-DD')
      let data = {
        date: date,
        shop: shopId,
      }
      this.apiPost(`/api/1.0/shops/reject-counter/decrement/`, null, {shopAs: shopId}, data).then(response => {
        this.rejectCount = response.body.count
      }).finally(() => {
      })
    },
    incrementRejectCount () {
      let shopId = this.$route.params.shopId
      let date = moment().format('YYYY-MM-DD')
      let data = {
        date: date,
        shop: shopId,
      }
      this.apiPost(`/api/1.0/shops/reject-counter/increment/`, null, {shopAs: shopId}, data).then(response => {
        this.rejectCount = response.body.count
      }).finally(() => {
      })
    },
    showGoalModal () {
      this.$refs.goalModal.show()
    },
  },
  watch: {
    date(val) {
      if (this.isReady && moment(val).isValid()) {
        const date = moment(val)
        this.$router.go({
          name: 'reservations',
          params: {
            year: date.format('YYYY'),
            month: date.format('MM'),
            day: date.format('DD'),
          },
        })
        this.fetchGoalData()
      }
    },
  },
  created () {
    this.$on('reservationRefresh', this.fetchGoalData)
  },
  ready () {
    this.fetchGoalData()
    this.fetchRejectCount()
  },
  vuex: {
    getters: {
      isWebSocketConnected: isWebSocketConnected,
    },
  },
  mixins: [
    require('mixin/login-required.vue'),
    require('mixin/api-client.vue'),
  ],
  components: {
    layout: require('layout.vue'),
    reservationFilter: require('reservation-filter.vue'),
    reservationsTable: require('./reservations-table/index.vue'),
    reservationSearch: require('./reservations-table/modal-form/search.vue'),
    goalModal: require('./reservations-table/modal-form/goal.vue'),
  },
  filters: {
    reservationCustomerName(reservation) {
      let customer = reservation.customer
      if (customer) {
        return `${customer.familyNameKana} ${customer.firstNameKana}`
      }
      return null
    },
    time(value) {
      if (!value) return value
      return moment(value).format('HH:mm')
    },
    locale(value) {
      if (!value) return value
      return Number(value).toLocaleString()
    },
  },
}
</script>



// WEBPACK FOOTER //
// index.vue?063a938e